import { useLayoutEffect, useRef, type ChangeEvent, type FC } from 'react';
import { useTheme } from 'styled-components';

import Icons from '../../../Elements/Icons/index.ts';
import { Input } from '../../../Form/Input/index.tsx';

interface SearchProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  value?: string;
  autofocus?: SearchInputAutofocus;
}

export type SearchInputAutofocus = boolean | { preventScroll: boolean };
export const AUTOFOCUS_WITHOUT_SCROLL = Object.freeze({ preventScroll: true });

export const Search: FC<SearchProps> = ({ onChange, onClear, value, autofocus = AUTOFOCUS_WITHOUT_SCROLL }) => {
  const theme = useTheme();
  const ref = useRef<HTMLInputElement>(null);

  useLayoutEffect(() => {
    if (autofocus) {
      ref.current?.focus({ preventScroll: typeof autofocus === 'object' ? autofocus.preventScroll : false });
    }
  }, [autofocus]);

  return (
    <Input
      placeholder='Search'
      icon={
        value ? (
          <Icons.Clear filled size={15} color={theme.colors.grey100_1} onClick={onClear} />
        ) : (
          <Icons.Search size={15} color={theme.colors.grey100_1} />
        )
      }
      onChange={onChange}
      isActionIcon={!!value}
      value={value}
      ref={ref}
      dataTestId='dropdown-search-input'
    />
  );
};
